export default __webpack_public_path__ + "static/media/level-up.87098ef8.svg";